module.exports = __webpack_public_path__ + "static/media/fa-solid-900.b557f56e.svg";